import CustomRichText from '@/components/CustomRichText';
import Image from 'next/image';
import { SerializedEditorState } from 'node_modules/lexical/LexicalEditorState';
import { ReactNode } from 'react';

interface AchievementItemProps {
  achievementItem: {
    icon?: string | { url: string; alt: string };
    width?: number;
    height?: number;
    title: ReactNode | SerializedEditorState;
    subtitle: ReactNode | SerializedEditorState;
  };
}
export default function AchievementItem({
  achievementItem: {
    icon = '/assets/icon/AchievementsIcon.svg',
    width = 45,
    height = 45,
    title,
    subtitle,
  },
}: AchievementItemProps) {
  return (
    <div
      data-meta="AchievementItem"
      className="flex flex-col justify-center gap-y-2 h-[300px] w-[300px] text-center border-white border rounded-full flex-shrink-0"
    >
      <Image
        width={width || 45}
        height={height || 45}
        src={typeof icon === 'string' ? icon : icon.url}
        alt={typeof icon === 'string' ? '' : icon.alt}
        className="mx-auto"
      />
      <CustomRichText
        data={title}
        tag="div"
        className="font-fixel text-center font-bold text-white"
      />
      <CustomRichText data={subtitle} tag="div" className="text-xs text-white p-3" />
    </div>
  );
}
